import { Clock, Plus, Pencil, Camera, Trash2, CalendarClock, RefreshCw, Hand } from "lucide-react";
import { formatWIB } from "@/lib/time";

const LABELS = {
  status: "Status",
  prioritas: "Prioritas",
  pic: "PIC",
  tgl_pelaksanaan: "Tgl Pelaksanaan",
  tgl_masuk: "Tgl Masuk",
  biaya: "Biaya",
  wilayah: "Wilayah",
  objek_lokasi: "Lokasi",
  jenis_pekerjaan: "Jenis",
  sumber: "Sumber",
  tim_pendamping: "Tim Pendamping",
  keterangan: "Keterangan",
  no_tiket: "No. Tiket",
  lat: "Latitude",
  lng: "Longitude",
  photos_before: "Foto Sebelum",
  photos_after: "Foto Sesudah",
  reschedule_reason: "Alasan Kendala",
  reschedule_notes: "Catatan Lapangan",
  completed_at: "Tgl Selesai",
};

const ACTION_META = {
  created:        { label: "Tiket Dibuat", icon: Plus,    color: "#0055FF" },
  updated:        { label: "Diperbarui",   icon: Pencil,  color: "#0055FF" },
  photo_uploaded: { label: "Foto Diunggah", icon: Camera, color: "#065F46" },
  photo_deleted:  { label: "Foto Dihapus", icon: Trash2,  color: "#991B1B" },
  rescheduled:    { label: "Ditunda / Reschedule", icon: CalendarClock, color: "#B45309" },
  auto_reset:     { label: "Auto-Reset 08:30", icon: RefreshCw, color: "#6B21A8" },
  claimed:        { label: "Diklaim Teknisi", icon: Hand, color: "#0369A1" },
  archive_corrected: { label: "Koreksi Arsip (Admin)", icon: Pencil, color: "#7C2D12" },
};

function fmt(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (typeof v === "number") return String(v);
  return String(v);
}

function fmtTime(iso) {
  if (!iso) return "";
  return formatWIB(iso);
}

export default function TicketHistory({ history }) {
  if (!history || history.length === 0) {
    return (
      <div className="text-sm text-[#9CA3AF] py-6 text-center border border-dashed border-[#E5E7EB] rounded-md" data-testid="ticket-history-empty">
        Belum ada riwayat perubahan.
      </div>
    );
  }
  const items = [...history].reverse();

  return (
    <div className="relative pl-8" data-testid="ticket-history">
      <div className="absolute left-3 top-2 bottom-2 w-px bg-[#E5E7EB]" />
      <ul className="space-y-5">
        {items.map((h, i) => {
          const meta = ACTION_META[h.action] || { label: h.action || "Aktivitas", icon: Pencil, color: "#6B7280" };
          const Icon = meta.icon;
          const isPhoto = h.action === "photo_uploaded" || h.action === "photo_deleted";
          const itemKey = `${h.at || ""}-${h.action || ""}-${i}`;
          return (
            <li key={itemKey} className="relative" data-testid={`history-item-${i}`}>
              <div
                className="absolute -left-8 top-0 h-6 w-6 rounded-full flex items-center justify-center border-2 bg-white"
                style={{ borderColor: meta.color, color: meta.color }}
              >
                <Icon className="h-3 w-3" strokeWidth={2.5} />
              </div>
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
                <span className="text-[11px] font-bold uppercase tracking-widest" style={{ color: meta.color }}>
                  {meta.label}
                </span>
                <span className="text-[#4B5563]">
                  oleh <span className="font-semibold text-[#0A0A0A]">{h.by_name || h.by || "System"}</span>
                </span>
                <span className="text-[#9CA3AF] flex items-center gap-1">
                  <Clock className="h-3 w-3" />
                  <span className="font-mono-tab">{fmtTime(h.at)}</span>
                </span>
              </div>
              {h.changes && h.changes.length > 0 && !isPhoto && (
                <ul className="mt-2 space-y-1 rounded-md bg-[#F8F9FA] border border-[#E5E7EB] px-3 py-2">
                  {h.changes.map((c, j) => (
                    <li key={`${itemKey}-${c.field || "chg"}-${j}`} className="text-xs leading-relaxed">
                      <span className="font-semibold text-[#0A0A0A]">{LABELS[c.field] || c.field}</span>
                      <span className="text-[#9CA3AF]">: </span>
                      <span className="text-[#991B1B] line-through decoration-[#991B1B]/40">{fmt(c.old)}</span>{" "}
                      <span className="text-[#9CA3AF]">→</span>{" "}
                      <span className="text-[#065F46] font-semibold">{fmt(c.new)}</span>
                    </li>
                  ))}
                </ul>
              )}
              {isPhoto && h.changes?.[0] && (
                <div className="mt-1.5 text-xs text-[#4B5563]">
                  {LABELS[h.changes[0].field] || h.changes[0].field}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
